import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import RecentlyViewedSlider from '@/common/components/RecentlyViewed/RecentlyViewedSlider';
import {
  getRecentlyViewed,
  RecentlyViewedProductV3,
} from '@/common/utils/recentlyViewed/recentlyViewed';

import styles from './RecentlyViewed.module.scss';

const MINIMUM_POSTERS_FOR_RECENTLY_VIEWED = 5;

const RecentlyViewedSection = () => {
  const router = useRouter();
  const [recentlyViewed, setRecentlyViewed] = useState<RecentlyViewedProductV3[]>([]);

  useEffect(() => {
    setRecentlyViewed(getRecentlyViewed());
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      setRecentlyViewed(getRecentlyViewed());
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);

  if (recentlyViewed.length < MINIMUM_POSTERS_FOR_RECENTLY_VIEWED) return null;

  return (
    <section className={styles.container} data-testid="recently-viewed-section">
      <h2 className={styles.title}>Recently viewed</h2>
      <RecentlyViewedSlider items={recentlyViewed} />
    </section>
  );
};

export default RecentlyViewedSection;
